import BasicChart from "components/dashboard/charts/BasicChart";
import { configLineChartData } from "components/dashboard/charts/ChartConfig/configLineChartData";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { ChartData } from "components/dashboard/dataset-window/models/types";
import React, { useState, useEffect } from "react";
import { handleRowReorderEvt } from "utils/utils";

interface XYValueMatrixProps {
  id: number;
  x: number;
  y: number;
  [key: string]: number;
}

const initialXYValues = [
  { id: 1, x: 1, y: 1 },
  { id: 2, x: 2, y: 2 },
  { id: 3, x: 3, y: 3 },
  { id: 4, x: 4, y: 4 },
  { id: 5, x: 5, y: 5 },
  { id: 6, x: 6, y: 6 },
];

const EditXYValueMatrix = () => {
  const [XYValues, setXYValues] = useState<XYValueMatrixProps[]>(initialXYValues);
  const [chartData, setChartData] = useState<ChartData[]>([]);

  useEffect(() => {
    setChartData(newChartData());
  }, [XYValues]);

  const newChartData = () => {
    const newChartDataObject: ChartData[] = [
      {
        id: "",
        unit: "Y", // y should be taken from config
        title: `X vs Y`, // X and Y should be taken from config
        keyArr: XYValues.map(item => item.x),
        valueArr: XYValues.map(item => item.y),
      },
    ];
    return newChartDataObject;
  };

  const addXYValues = () => {
    setXYValues([...XYValues, { id: XYValues.length + 1, x: 0, y: 0 }]);
  };

  const handleValuesChange = (rowData: XYValueMatrixProps, field: string, value: number) => {
    setXYValues(prevState => {
      const updatedValues = [...prevState];
      updatedValues[rowData.rowIndex][field] = Number(value);
      return updatedValues;
    });
    setChartData(newChartData());
  };

  const removeValues = (index: number) => {
    const updatedValues = XYValues.filter((value, i) => i !== index);
    setXYValues(updatedValues);
  };

  const onRowEditComplete = (e: any) => {
    const datasetsToUpdate = [...XYValues];
    const { newData, index } = e;
    delete newData.index;
    datasetsToUpdate[index] = e.data;
    setXYValues(XYValues);
  };

  const colorPallet = {
    value: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b"],
  };

  const selectedChartType = "LINE";

  const handleTableChange = (e: any) => {
    // handleRowReorderEvt(XYValues, setXYValues)(e);
    setChartData(newChartData());
  };

  const columnBodyInputTemplate = (rowData: XYValueMatrixProps, rowOptions: any) => {
    return (
      <InputText
        value={rowData[rowOptions.field]}
        style={{ padding: "4px", width: "50%" }}
        onChange={(e: any) => handleValuesChange(rowOptions, rowOptions.field, Number(e.target.value))}
        keyfilter="int"
      />
    );
  };

  const removeButton = (index: number) => (
    <Button
      icon="pi pi-trash"
      className="const-del-btn  p-button-rounded p-button-text p-button-danger"
      onClick={() => removeValues(index)}
    />
  );

  return (
    <div>
      <DataTable
        value={XYValues}
        onRowEditComplete={onRowEditComplete}
        editMode="row"
        reorderableRows
        onRowReorder={handleTableChange}
        style={{ paddingBottom: "5px" }}
      >
        <Column rowReorder style={{ width: "3%", padding: "1px" }} />
        <Column
          field="x"
          header={
            <div className="flex align-items-center">
              <div>X value</div> {/* X should be taken from the config */}
            </div>
          }
          style={{ padding: "1px" }}
          body={(rowData, rowIndex) =>
            columnBodyInputTemplate(rowData, rowIndex)
          }
        />
        <Column
          field="y"
          header={
            <div className="flex align-items-center">
              <div>Y value</div> {/* Y should be taken from the config */}
            </div>
          }
          style={{ padding: "1px" }}
          body={(rowData, rowIndex) =>
            columnBodyInputTemplate(rowData, rowIndex)
          }
        />
        <Column
          style={{ width: "40%", textAlign: "right", padding: "1px" }}
          body={(options: any) => removeButton(options.rowIndex)}
        />
      </DataTable>
      <div className="flex justify-content-between">
        <div>
          <Button
            className="p-button-outlined p-button-secondary"
            label="Add"
            onClick={addXYValues}
          />
        </div>
        <div className="flex gap-2">
          <Button
            className="p-button-success"
            label={!XYValues.length ? "Create" : "Save"}
            onClick={() => console.log(XYValues)}
          />
          <Button
            className="p-button-danger"
            label="Cancel"
            onClick={() => console.log(XYValues)}
          />
        </div>
      </div>
      <BasicChart
        plotData={configLineChartData(chartData, colorPallet.value)}
        props={{
          xaxisName: "X", // X should be taken from the config
          identifiers: [],
          hideRefresh: true,
          height: 300,
          selectedChartType,
        }}
      />
    </div>
  );
};

export default EditXYValueMatrix;
